// extracted by mini-css-extract-plugin
export default {"content":"ProfilePersonalDetails_content__HP19r","realContent":"ProfilePersonalDetails_realContent__ON1SC"};